// extracted by mini-css-extract-plugin
export default {"container":"cI-z","disabled":"dI-z","bgBlack":"eI-z","content":"fI-z","countdown":"gI-z","topCaption":"hI-z","topHeading":"iI-z","heading":"jI-z","copy":"kI-z"};